import type { ReactNode } from "react";

export type EmptyStateAction = {
  label: string;
  onClick: () => void;
  variant?: "primary" | "ghost";
};

export type EmptyStateProps = {
  title: string;
  body?: string;
  action?: EmptyStateAction;
  icon?: ReactNode;
};

export function EmptyState({ title, body, action, icon }: EmptyStateProps) {
  const variantClass = action?.variant === "ghost" ? "btn--ghost" : "btn--primary";
  return (
    <div className="empty-state">
      {icon}
      <h3 className="empty-state__title">{title}</h3>
      {body ? (
        <p className="empty-state__body" data-testid="empty-state-body">
          {body}
        </p>
      ) : null}
      {action ? (
        <button type="button" className={`btn ${variantClass}`} onClick={action.onClick}>
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
